import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { ConstantService } from "../../../services/ConstantService";
import CustomNumberInput from "../../../components/CustomNumberInput";
import { CompanyService } from "../../../services/CompanyService";
import { ServiceService } from "../../../services/ServiceService";
import CustomTextInput from "../../../components/CustomTextInput";
import CustomDatePicker from "../../../components/CustomDatePicker";
import CustomSwitch from "../../../components/CustomSwitch";
import { AddCompanyPoRequest } from "../../../models/request/companyPo/AddCompanyPoRequest";
import { ProjectEnum } from "../../../models/common/Enums";
import { CompanyPoService } from "../../../services/CompanyPoService";
import { GetCompanyPoByIdResponse } from "../../../models/response/companyPo/GetCompanyPoByIdResponse";
import { AddCompanyPoResponse } from "../../../models/response/companyPo/AddCompanyPoResponse";
import { YurticiCargoService } from "../../../services/YurticiCargoService";

const CompanyPoAdd = () => {
    const navigate = useNavigate();
    const pageName = "Genel Tanımlamalar > PO Eşleştirme"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();

    const [companyPoId, setCompanyPoId] = useState<string | undefined>(undefined);
    const [selectedProject, setSelectedProject] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [senderCode, setSenderCode] = useState<string | undefined>(undefined);
    const [selectedCustomer, setSelectedCustomer] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedDivision, setSelectedDivision] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedPo, setSelectedPo] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [poNo, setPoNo] = useState<string | undefined>(undefined);
    const [startDate, setStartDate] = useState<string | undefined>(undefined);
    const [endDate, setEndDate] = useState<string | undefined>(undefined);
    const [isCustomActive, setIsCustomActive] = useState(true);

    // "Gönderici - Alıcı Kayıtlı Değil" (04.10.2026): açıksa kod zorunlu değil, eşleştirme bu alanlarla yapılır.
    const [isUnregistered, setIsUnregistered] = useState(false);
    const [selectedReceiverCustomer, setSelectedReceiverCustomer] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedArrivalUnit, setSelectedArrivalUnit] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedSenderCustomer, setSelectedSenderCustomer] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [matchDeliverer, setMatchDeliverer] = useState<string | undefined>(undefined);
    const [matchDeliveryReceiver, setMatchDeliveryReceiver] = useState<string | undefined>(undefined);

    const yurticiProjesi = selectedProject?.additionalValue1 == ProjectEnum.YURTICI_KARGO;

    // Yurtiçi Alıcı / Gönderici seçimi: Yurtiçi entegrasyonundan gelen firmalar (Firma Durumu boş, müşteri değil, aktif)
    // ve sırasıyla "Alıcı Firma" / "Gönderici Firma" işaretli olanlar (Burak, 04.10.2026).
    const entegrasyonFirmalari = (tur: 'alici' | 'gonderici') => CompanyService.getCompanyList({
        isCustomer: false,
        onlyWithoutCompanyType: true,
        selectedIsCustomActives: [{ label: 'Aktif', value: '1' }] as any,
        ...(tur == 'alici' ? { isReceiverFirm: true } : { isSenderFirm: true }),
    });

    // Anahtar yalnız Yurtiçi Kargo projesinde açılabilir.
    const kayitsizDegistir = (deger: React.SetStateAction<boolean>) => {
        const yeniDeger = typeof deger === 'function' ? deger(isUnregistered) : deger;

        if (yeniDeger && !yurticiProjesi) {
            toast.error("Öncelikle Proje alanından Yurtiçi Kargo seçilmelidir.");
            return;
        }

        setIsUnregistered(yeniDeger);
    }

    // Proje Yurtiçi Kargo dışına çekilirse anahtar kapanır.
    const projeDegistir = (proje: any) => {
        setSelectedProject(proje);

        if (proje?.additionalValue1 != ProjectEnum.YURTICI_KARGO)
            setIsUnregistered(false);
    }

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetCompanyPoByIdResponse = await CompanyPoService.getCompanyPoById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setCompanyPoId(response.data.companyPoId);
                setSenderCode(response.data.senderCode);

                if (response.data.projectId && response.data.projectName)
                    setSelectedProject({ label: response.data.projectName, value: response.data.projectId, additionalValue1: response.data.projectKey });

                if (response.data.customerId && response.data.customerName)
                    setSelectedCustomer({ label: response.data.customerName, value: response.data.customerId });

                if (response.data.divisionId && response.data.divisionName)
                    setSelectedDivision({ label: response.data.divisionName, value: response.data.divisionId });

                if (response.data.poId && response.data.poName)
                    setSelectedPo({ label: response.data.poName, value: response.data.poId });

                setPoNo(response.data.poNo);
                setStartDate(response.data.startDate);
                setEndDate(response.data.endDate);
                setIsCustomActive(response.data.isCustomActive);
                setIsUnregistered(!!response.data.isSenderReceiverUnregistered);
                if (response.data.matchReceiverCustomerId && response.data.matchReceiverCustomerName)
                    setSelectedReceiverCustomer({ label: response.data.matchReceiverCustomerName, value: response.data.matchReceiverCustomerId });

                if (response.data.matchSenderCustomerId && response.data.matchSenderCustomerName)
                    setSelectedSenderCustomer({ label: response.data.matchSenderCustomerName, value: response.data.matchSenderCustomerId });
                setMatchDeliverer(response.data.matchDeliverer);
                setMatchDeliveryReceiver(response.data.matchDeliveryReceiver);

                if (response.data.matchArrivalUnitId && response.data.matchArrivalUnitName)
                    setSelectedArrivalUnit({ label: response.data.matchArrivalUnitName, value: response.data.matchArrivalUnitId });
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }
    const saveCompanyPo = async () => {
        try {
            if (!selectedProject) {
                toast.error("Proje alanı zorunludur.");
                return;
            }

            if (isUnregistered) {
                if (selectedProject.additionalValue1 != ProjectEnum.YURTICI_KARGO) {
                    toast.error("Öncelikle Proje alanından Yurtiçi Kargo seçilmelidir.");
                    return;
                }

                // Kodsuz tanımda koşul Yurtiçi Alıcı / Varış Birimi / Yurtiçi Gönderici'dir (Teslim alanları yalnız öncelik).
                // Kodlu tanımda kod da koşuldur (06.10.2026).
                if (!senderCode && !selectedReceiverCustomer && !selectedArrivalUnit && !selectedSenderCustomer) {
                    toast.error("Gönderici - Alıcı Kodu, Yurtiçi Alıcı, Varış Birimi ya da Yurtiçi Gönderici alanlarından en az biri doldurulmalıdır.");
                    return;
                }
            }
            // Gönderici - Alıcı Kodu yalnızca Yurtiçi Kargo projesinde ve anahtar kapalıyken zorunlu.
            else if (selectedProject.additionalValue1 == ProjectEnum.YURTICI_KARGO && !senderCode) {
                toast.error("Yurtiçi Kargo projesinde Gönderici - Alıcı Kodu zorunludur.");
                return;
            }

            dispatch(storeActivityIndicator(true));

            var obj: AddCompanyPoRequest = {
                companyPoId: companyPoId,
                projectId: selectedProject.value,
                customerId: selectedCustomer?.value,
                divisionId: selectedDivision?.value,
                endDate: endDate,
                isCustomActive: isCustomActive,
                poId: selectedPo?.value,
                poNo: poNo,
                senderCode: senderCode,
                startDate: startDate,
                isSenderReceiverUnregistered: isUnregistered,
                matchReceiverCustomerId: isUnregistered ? selectedReceiverCustomer?.value : undefined,
                matchArrivalUnitId: isUnregistered ? selectedArrivalUnit?.value : undefined,
                matchSenderCustomerId: isUnregistered ? selectedSenderCustomer?.value : undefined,
                matchDeliverer: isUnregistered ? matchDeliverer : undefined,
                matchDeliveryReceiver: isUnregistered ? matchDeliveryReceiver : undefined,
            };

            var response: AddCompanyPoResponse = await CompanyPoService.addCompanyPo(obj);

            if (!response.isSuccess) {
                toast.error(response.message);
                dispatch(storeActivityIndicator(false));
                return;
            }

            toast.success(response.message)

            dispatch(storeActivityIndicator(false));
            navigate(Helpers.getGoBackUrl())
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <div>
                        <KTCard className="ebbe-card">
                            <KTCardBody>
                                <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                                {/* En üstte, varsayılan pasif. Açılınca eşleştirme alanları hemen altında açılır, diğer alanlar aşağı kayar. */}
                                <div className="row mb-5">
                                    <div className="col-md-4">
                                        <label htmlFor="kayitsizAnahtar" className="form-label">Gönderici - Alıcı Kayıtlı Değil</label>

                                        <CustomSwitch isActive={isUnregistered} setIsActive={kayitsizDegistir} />
                                    </div>
                                </div>

                                {
                                    isUnregistered && (
                                        <div className="mb-5 p-5 rounded border border-dashed border-primary">
                                            <div className="text-muted fs-7 mb-4">Müşterisi firmanın kendisi olan ya da boş olan ve Bölüm / PO / PO Numarası boş kalan Yurtiçi Kargo gönderileri bu tanımla eşleştirilir. <b>Gönderici - Alıcı Kodu doluysa</b> önce kargonun gönderici (yoksa alıcı, yoksa fatura) müşteri kodu tutmalı; ayrıca Yurtiçi Gönderici, Varış Birimi, Yurtiçi Alıcı ve Teslim Eden'den doldurulanların hepsi tutmalıdır. Kodlu tanımlara kodsuzlardan önce bakılır. <b>Kod boşsa</b> Yurtiçi Alıcı, Varış Birimi ve Yurtiçi Gönderici'den doldurulanların hepsi tutmalıdır; Teslim Eden / Teslim Alan yalnız öncelik verir. Eşleşen kargolar listede "Otomatik" görünür.</div>

                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label htmlFor="matchReceiverCustomer" className="form-label">Yurtiçi Alıcı</label>

                                                    <CustomSingleSelect
                                                        selectedValue={selectedReceiverCustomer}
                                                        onChange={setSelectedReceiverCustomer}
                                                        onMenuOpen={() => entegrasyonFirmalari('alici')}
                                                        labelName='name'
                                                        valueName='companyId'
                                                    />
                                                </div>

                                                <div className="col-md-4">
                                                    <label htmlFor="matchArrivalUnit" className="form-label">Varış Birimi</label>

                                                    <CustomSingleSelect
                                                        selectedValue={selectedArrivalUnit}
                                                        onChange={setSelectedArrivalUnit}
                                                        onMenuOpen={() => YurticiCargoService.getYurticiCargoUnitList()}
                                                        labelName='countyName'
                                                        valueName='id'
                                                        label2Name="districtName"
                                                        label3Name="name"
                                                    />
                                                </div>

                                                <div className="col-md-4">
                                                    <label htmlFor="matchSenderCustomer" className="form-label">Yurtiçi Gönderici</label>

                                                    <CustomSingleSelect
                                                        selectedValue={selectedSenderCustomer}
                                                        onChange={setSelectedSenderCustomer}
                                                        onMenuOpen={() => entegrasyonFirmalari('gonderici')}
                                                        labelName='name'
                                                        valueName='companyId'
                                                    />
                                                </div>
                                            </div>

                                            <div className="row mt-5">
                                                <div className="col-md-4">
                                                    <label htmlFor="matchDeliverer" className="form-label">Teslim Eden <span className="text-muted fw-normal fs-8">(kodlu tanımda şart, kodsuzda öncelik)</span></label>

                                                    <CustomTextInput value={matchDeliverer} setValue={setMatchDeliverer} />
                                                </div>

                                                <div className="col-md-4">
                                                    <label htmlFor="matchDeliveryReceiver" className="form-label">Teslim Alan <span className="text-muted fw-normal fs-8">(öncelik için)</span></label>

                                                    <CustomTextInput value={matchDeliveryReceiver} setValue={setMatchDeliveryReceiver} />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }

                                <div className="row">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Proje</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedProject}
                                            onChange={projeDegistir}
                                            onMenuOpen={() => ConstantService.getConstantList('PROJECT')}
                                            labelName='value'
                                            valueName="constantId"
                                            additionalValue1Name='additionalValue1'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className={"form-label " + (yurticiProjesi && !isUnregistered ? "required" : "")}>Gönderici - Alıcı Kodu</label>

                                        <CustomNumberInput value={senderCode} setValue={setSenderCode} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Müşteri</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedCustomer}
                                            onChange={setSelectedCustomer}
                                            onMenuOpen={[
                                                () => CompanyService.getCompanyList({ isCustomer: true })
                                            ]}
                                            labelName='name'
                                            valueName='companyId'
                                        />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Bölüm</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedDivision}
                                            onChange={setSelectedDivision}
                                            onMenuOpen={() => ConstantService.getConstantList('DIVISION')}
                                            labelName='value'
                                            valueName="constantId"
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">PO</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedPo}
                                            onChange={setSelectedPo}
                                            onMenuOpen={() => ServiceService.getServiceList(true)}
                                            labelName='name'
                                            valueName='serviceId'
                                            additionalValue1Name='incomePercentageName'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">PO Numarası</label>

                                        <CustomTextInput value={poNo} setValue={setPoNo} />
                                    </div>
                                </div>

                                <div className='row mt-5'>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Başlangıç Tarihi</label>

                                        <CustomDatePicker value={startDate} setValue={setStartDate} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Bitiş Tarihi</label>

                                        <CustomDatePicker value={endDate} setValue={setEndDate} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Aktif</label>

                                        <CustomSwitch isActive={isCustomActive} setIsActive={setIsCustomActive} />
                                    </div>
                                </div>
                            </KTCardBody>
                        </KTCard>
                    </div>

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveCompanyPo}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default CompanyPoAdd;